const env =  window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const companyURL = getURL( 'https://(env.)api.biw.cloud/v1/company-setup' );
export const giftCodeURL = getURL( 'https://(env.)api.biw.cloud/v1/gift-code' );
export const serviceAwardsURL = getURL( 'https://(env.)api.biw.cloud/v1/service-awards' );
export const permMgrApiUrl = getURL( 'https://(env.)api.biw.cloud/v1/permissions-manager' );
export const cmxURL = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );

export const permMgrUrl = getURL( 'https://permissions-manager.(env.)biw.cloud' );
export const rosterGroupsUrl = getURL( 'https://(env.)roster-groups.biw.cloud' );
export const companyAdminURL = getURL( 'https://company-admin.(env.)biw.cloud' );
export const serviceAwardsAdminURL = getURL( 'https://serviceawards-admin.(env.)biw.cloud' );
export const rosterURL = 'https://(env.)api.biw.cloud/v1/roster';


